<template>
  <PicturesScreen
    :isIntroScreen
    :machine-send="resolutionFlowStateMachine.send"
    :pictures
    @submit="goToContact"
  />
</template>

<script setup lang="ts">
import { navigateTo, useRouteLocationWithLocale } from '#imports'
import { computed, inject } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

import PicturesScreen from '~/scopes/customer-care/resolution/components/ResolutionFlowScreens/screens/Return/PicturesScreen/PicturesScreen.vue'
import type { ProvideResolutionFlowMachine } from '~/scopes/customer-care/resolution/machine/ResolutionFlow.machine.types'
import { ResolutionFlowStateMachineKey } from '~/scopes/customer-care/resolution/symbols'
import { CUSTOMER_CARE } from '~/scopes/customer-care/route-names'

const resolutionFlowStateMachine = inject(
  ResolutionFlowStateMachineKey,
) as ProvideResolutionFlowMachine

const resolveLocalizedRoute = useRouteLocationWithLocale()
const goToContact = async () => {
  await navigateTo(
    resolveLocalizedRoute({
      name: CUSTOMER_CARE.RESOLUTION.EXPRESS_REPLACEMENT.CONTACT,
    }) as RouteLocationRaw,
  )
}
// TODO: REFACTOR TO REMOVE PREFIX RETURN FUNNEL
const isIntroScreen = computed(() =>
  resolutionFlowStateMachine.state.value.matches(
    'RETURN_FUNNEL.PICTURES_INTRO',
  ),
)

const pictures = computed(
  () => resolutionFlowStateMachine.state.value.context.customerInput.pictures,
)

resolutionFlowStateMachine.send('GO_TO_PICTURES')
</script>
